var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVideoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 5.65716C17.6 4.47853 16.6133 3.52002 15.4 3.52002H2.2C0.9867 3.52002 0 4.47853 0 5.65716V16.3429C0 17.5215 0.9867 18.48 2.2 18.48H15.4C16.6133 18.48 17.6 17.5215 17.6 16.3429V12.7813L22 16.3429V5.65716L17.6 9.21871V5.65716Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoWhite);
export default __webpack_public_path__ + "static/media/ic-video-white.1b73d322774ba0fe0a61451b8431b315.svg";
export { ForwardRef as ReactComponent };